import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["navigationPriority", "groupName"],
  _excluded2 = ["props"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _sortBy from 'lodash/sortBy';
import _values from 'lodash/values';
function getIndividualLinks(links) {
  return links.filter(function (_ref) {
    var groupName = _ref.groupName;
    return _isEmpty(groupName);
  });
}
export function sortLinks(links) {
  return _sortBy(links, ['navigationPriority']);
}
export function createLinkGroups(links) {
  var groups = links.reduce(function (linkGroups, link) {
    var groupName = link.groupName;
    if (groupName) {
      return _objectSpread(_objectSpread({}, linkGroups), {}, _defineProperty({}, groupName, linkGroups[groupName] ? [].concat(_toConsumableArray(linkGroups[groupName]), [link]) : [link]));
    }
    return linkGroups;
  }, {});
  return Object.keys(groups).reduce(function (acc, groupName) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, groupName, sortLinks(groups[groupName])));
  }, {});
}
function linksToGroupOfLinks(individualLinks, groupedLinks) {
  return [].concat(_toConsumableArray(individualLinks), _toConsumableArray(_values(groupedLinks))).map(function (linkOrGroup) {
    if (_isArray(linkOrGroup)) {
      var firstGroupItem = linkOrGroup[0];
      var groupName = firstGroupItem.groupName,
        navigationPriority = firstGroupItem.navigationPriority;
      return {
        navigationPriority: navigationPriority,
        title: groupName,
        links: linkOrGroup
      };
    }
    return linkOrGroup;
  });
}
export function cleanLinkProps(links) {
  return links.map(function (_ref2) {
    var navigationPriority = _ref2.navigationPriority,
      groupName = _ref2.groupName,
      link = _objectWithoutProperties(_ref2, _excluded);
    return link;
  });
}
export function transformLinks(links) {
  return links.map(function (link) {
    var props = link.props,
      rest = _objectWithoutProperties(link, _excluded2);
    if (props) {
      return _objectSpread(_objectSpread({}, JSON.parse(props)), rest);
    }
    return rest;
  });
}
export function groupLinks(links) {
  var transformedLinks = transformLinks(links);
  var individualLinks = getIndividualLinks(transformedLinks);
  var linkGroups = createLinkGroups(transformedLinks);
  var mergedLinks = linksToGroupOfLinks(individualLinks, linkGroups);
  var sortedLinks = sortLinks(mergedLinks);
  var cleanedLinks = cleanLinkProps(sortedLinks);
  return cleanedLinks;
}